import React from "react";
import Layout from "../components/Layout";

function Help() {
    const sections = [
        {
            title: "1. Changing Area Names",
            content: [
                "Go to **Masters > DS Manager**.",
                "Find the Salesman in the list and click **Edit**.",
                "Update the area names for specific days (MON-SAT) in the 'Day Schedule Areas' section.",
                "Click **Update Distributor Salesman** to save."
            ]
        },
        {
            title: "2. Moving an Outlet to a New Day",
            content: [
                "Go to **Masters > Outlet Master**.",
                "In the 'Outlet List', find the shop you want to move.",
                "Click **Edit** on that shop.",
                "Change the **Select Day** dropdown (e.g., from MON to TUE).",
                "The **Area Name** will automatically update to the salesman's schedule for that day.",
                "Click **Update Outlet** to confirm the move."
            ]
        },
        {
            title: "3. Reassigning a Beat to a Different Salesman",
            content: [
                "Go to **Masters > Outlet Master**.",
                "Switch to the **Bulk Reassign** tab (coming soon or use individual edit).",
                "Select the 'Current Salesman' and 'Current Day'.",
                "Select the 'New Salesman' and 'New Target Day'.",
                "Click **Execute Bulk Reassign**.",
                "All outlets for that specific day will be moved to the new salesman immediately."
            ]
        },
        {
            title: "4. Managing Outlet Status",
            content: [
                "In the **Outlet Master > Outlet List**, you will see a green or red button under 'Status'.",
                "Click the button to toggle between **Active** and **Inactive**.",
                "**Inactive** outlets will be hidden from the salesman's mobile dashboard until you reactivate them."
            ]
        },
        {
            title: "5. Bulk Uploading Details (Excel)",
            content: [
                "You can upload large lists of Salesmen or Outlets via the **Bulk Upload (XLSX)** tab in their respective pages.",
                "**Templates**: Click the **📥 Download Template (.xlsx)** button in the Bulk Upload tab to get a pre-formatted file with the correct headers.",
                "**For Salesmen**: Required columns are `dsId`, `name`, `phone`, `distributorId`, `route`, `activeOutlets`, `vehicleNo`, `monArea`, `tueArea`, `wedArea`, `thuArea`, `friArea`, `satArea`.",
                "**For Outlets**: Required columns are `outletId`, `name`, `phone`, `address`, `dsId`, `beat` (e.g. MON), `lat`, `long`.",
                "After updating the template with your data, upload it, review the preview, and click **Confirm Upload**."
            ]
        },
        {
            title: "6. DS Onboarding & Login Support",
            content: [
                "To onboard a Salesman (DS) for mobile login:",
                "**1. DS Manager**: Go to **Masters > DS Manager**.",
                "**2. Create Login**: Find the Salesman in the 'DS List' and click the green **Create Login** button.",
                "**3. Credentials**: Enter their Email and a Password (at least 6 characters).",
                "**4. Done**: The system will automatically create their portal account and map it to their DS ID.",
                "**5. Access**: The salesman can now login at the portal home page using their credentials to access the mobile dashboard."
            ]
        },
        {
            title: "7. DS Order Report & Export",
            content: [
                "Admins can track mobile sales in the **Masters > DS Order Report** page.",
                "Each order shows the exact **Basic Amount**, **CGST**, **SGST**, and **Total Amount** calculated based on the SKU Master.",
                "Captured **Geolocation (Lat/Long)** allows you to verify the salesman's visit at the shop location.",
                "Click **📊 Export to Excel** for a full data dump with item-level details."
            ]
        }
    ];

    return (
        <Layout>
            <div style={{ padding: 30, maxWidth: 900, margin: "0 auto" }}>
                <h1 style={{ color: "#333", borderBottom: "2px solid #007bff", paddingBottom: 10 }}>
                    QuickBill Admin Guide
                </h1>
                <p style={{ fontSize: 16, color: "#666", marginBottom: 30 }}>
                    Step-by-step instructions for managing your Salesmen, Outlets, and Schedules.
                </p>

                {sections.map((section, idx) => (
                    <div key={idx} style={cardStyle}>
                        <h3 style={sectionTitle}>{section.title}</h3>
                        <ol style={listStyle}>
                            {section.content.map((item, i) => (
                                <li key={i} style={listItem}>
                                    {item.split("**").map((part, pidx) =>
                                        pidx % 2 === 1 ? <strong key={pidx}>{part}</strong> : part
                                    )}
                                </li>
                            ))}
                        </ol>
                    </div>
                ))}

                <div style={infoBox}>
                    <h4>💡 Pro Tip: Geolocation Accuracy</h4>
                    <p>
                        When a salesman places an order on their mobile, we capture the exact Latitude and Longitude.
                        You can view these coordinates in the **Outlet Master** list to verify they were actually at the shop.
                    </p>
                </div>
            </div>
        </Layout>
    );
}

const cardStyle = {
    background: "#fff",
    borderRadius: 8,
    padding: 20,
    marginBottom: 20,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    border: "1px solid #eee"
};

const sectionTitle = {
    marginTop: 0,
    color: "#007bff",
    fontSize: 20,
    marginBottom: 15
};

const listStyle = {
    paddingLeft: 20,
    margin: 0
};

const listItem = {
    marginBottom: 10,
    fontSize: 15,
    lineHeight: "1.6",
    color: "#444"
};

const infoBox = {
    marginTop: 40,
    background: "#e3f2fd",
    padding: 20,
    borderRadius: 8,
    borderLeft: "5px solid #007bff"
};

export default Help;
